import { Outlet } from "react-router-dom";
import { Stack, styled } from "@mui/material";

export const UserSettingLayout = () => {
  return (
    <UserSettingLayoutWrapper>
      <Outlet />
    </UserSettingLayoutWrapper>
  );
};

const UserSettingLayoutWrapper = styled(Stack)`
  width: 1198px;
  margin: 0 auto;
`;
